
  import cloudflareRuntime$L_452BQCBmDkVV93z_B7EQWHsIOOWaQUojRgk7_oO_45G7A from '/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@nuxt/image/dist/runtime/providers/cloudflare'
import ipxRuntime$_6Gn_ovavydlLiUfVtLx0pOR_45L4UpS75A2Cwefrm_45s18 from '/data/gitlab-runner/builds/vxUBjD1hN/0/spilnu/frontend/luxcasino-uk/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 414,
    "md": 768,
    "lg": 1024,
    "xl": 1366,
    "2xl": 1536,
    "xs": 360,
    "xxl": 1920
  },
  "presets": {
    "gameservice": {
      "baseURL": "https://media.platego.io"
    },
    "local": {
      "baseURL": "/"
    },
    "heroDev": {
      "baseURL": "https://stage.luxcasino.co.uk"
    },
    "heroStage": {
      "baseURL": "https://stage.luxcasino.co.uk"
    },
    "heroProd": {
      "baseURL": "https://www.luxcasino.co.uk"
    }
  },
  "provider": "ipx",
  "domains": [
    "media.platego.io",
    "stage.luxcasino.co.uk"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    /** @type {"ipx"} */
    provider: "ipx",
    providers: {
        ['cloudflare']: { setup: cloudflareRuntime$L_452BQCBmDkVV93z_B7EQWHsIOOWaQUojRgk7_oO_45G7A, defaults: {"baseURL":"https://media.platego.io","modifiers":{"quality":"64"}} },
  ['ipx']: { setup: ipxRuntime$_6Gn_ovavydlLiUfVtLx0pOR_45L4UpS75A2Cwefrm_45s18, defaults: {} }
    }
  }
